import { useQuery, UseQueryResult } from 'react-query';
import { CancelToken } from 'axios';

import { axiosInstance, cancelWrapper } from '@API/api';

interface ResourceVersion {
  version: string;
  url: string;
  isDefault: boolean;
}

export interface Resource {
  name: string;
  versions: ResourceVersion[];
}

interface GetPanelTemplateRevisionsResponse {
  resources: Resource[];
}

const getPanelTemplateRevisions = async (): Promise<Resource[]> =>
  cancelWrapper(async (cancelToken: CancelToken) => {
    const { data } = await axiosInstance.get<GetPanelTemplateRevisionsResponse>(
      'code-visualizations/template/code/resources/defaults/get',
      { cancelToken }
    );

    return data.resources;
  });

export default function usePanelTemplateInternalResources(): UseQueryResult<
  Resource[]
> {
  return useQuery(
    ['panelTemplateInternalResources'],
    getPanelTemplateRevisions
  );
}
